import { vDriveDeliveryStatus } from './api/wallet.types';

/**
 * What sends an automatic message: a delivery reaching a status, or the customer's ETA moving
 * later. There can be one `etaIncreased` message and it never has a status.
 */
export enum IncidentMessageType {
  status = 'status',
  etaIncreased = 'etaIncreased',
}

export interface IncidentMessage {
  id: number;
  type: IncidentMessageType;
  /** `null` for an `etaIncreased` message. */
  status: vDriveDeliveryStatus | null;
  message: string;
  enabled: boolean;
}

export interface CreateIncidentMessageDto {
  /** The backend defaults a missing type to `status`. */
  type?: IncidentMessageType;
  /** Required for a status message, never sent for `etaIncreased`. */
  status?: vDriveDeliveryStatus;
  message: string;
  enabled: boolean;
}

export type UpdateIncidentMessageDto = Partial<CreateIncidentMessageDto>;
